import React from 'react';
import { useTranslation } from 'react-i18next';
import { openLiveMessagingOrNative } from '@account-verification-frontend/types';
import './LiveMessagingLink.scss';
const CHAT_LOCATION = 'ireland-verification-journey';
export const LiveMessagingLink = () => {
    const { t } = useTranslation();
    const handleClick = async () => {
        await openLiveMessagingOrNative({ location: CHAT_LOCATION });
    };
    return (React.createElement("button", { type: "button", className: "live-messaging-link", onClick: handleClick, "data-test-id": "live-messaging-link" }, t('live-messaging.title')));
};
//# sourceMappingURL=LiveMessagingLink.js.map